import { Component, Input } from "@angular/core";
import { FilterService, BaseFilterCellComponent } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  standalone: false,
  selector: "dropdown-filter",
  templateUrl: './dropdown-filter.component.html',
  providers: [FilterService]
})
export class DropDownFilterComponent extends BaseFilterCellComponent {
  public get selectedValue(): unknown {
    const filter = this.filterByField(this.filterField);
    return filter ? filter.value : null;
  }

  @Input() public filter: CompositeFilterDescriptor = null;
  @Input() public data: unknown[];
  @Input() public textField: string;
  @Input() public valueField: string;
  @Input() public filterField: string;

  public get defaultItem(): { [Key: string]: unknown } {
    return {
      [this.textField]: "(All)",
      [this.valueField]: null,
      [this.filterField]: null
    };
  }

  constructor(filterService: FilterService) {
    super(filterService);
  }

  public onChange(value: unknown): void {
    this.applyFilter(
      value === null
        ? this.removeFilter(this.filterField)
        : this.updateFilter({
            field: this.filterField,
            operator: "eq",
            value: value,
          })
    );
  }
}